// extracted by mini-css-extract-plugin
export default {"headingOverride":"styles_headingOverride__Wrml1","customize":"styles_customize__JoJhJ","description":"styles_description__iRcZV","editorBox":"styles_editorBox__mCHv-"};